import { Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import moment from 'moment/moment'
import {
  BricksIconComponent,
  BricksModalBodyComponent,
  BricksModalComponent,
  BricksModalFooterComponent,
  BricksModalHeaderComponent,
} from '@enbw_bricks/ui'
import { DateDayMonthYearPipe } from '../../../shared/pipes/dateGermanFormat'

export interface SubsidizedPeriodModalData {
  contractStartDate: moment.Moment
  validContractStartDate: moment.Moment | null
  contractEndDate: moment.Moment
  validContractEndDate: moment.Moment | null
}

export enum ContractAdjustmentOption {
  AdjustEndDate = 'AdjustEndDate',
  AdjustStartDate = 'AdjustStartDate',
  ChangeMarketingType = 'ChangeMarketingType',
}

@Component({
  selector: 'app-commissioning-date-modal',
  imports: [
    BricksModalBodyComponent,
    BricksModalComponent,
    BricksModalFooterComponent,
    BricksModalHeaderComponent,
    BricksIconComponent,
    DateDayMonthYearPipe,
  ],
  templateUrl: 'subsidized-period-modal.component.html',
  styleUrl: './subsidized-period-modal.component.scss',
})
export class SubsidizedPeriodModalComponent {
  private readonly matDialogRef = inject<MatDialogRef<SubsidizedPeriodModalComponent>>(MatDialogRef)
  protected readonly data = inject<SubsidizedPeriodModalData>(MAT_DIALOG_DATA)

  protected readonly ContractAdjustmentOption = ContractAdjustmentOption

  closeDialog(option?: ContractAdjustmentOption) {
    this.matDialogRef.close(option)
  }

  get showStartDateOption(): boolean {
    return !!this.data.validContractStartDate && !this.data.validContractStartDate.isSame(this.data.contractStartDate)
  }
}
